/* FLUID theme JS — lightweight, dependency-free. */
(function () {
  'use strict';
  const F = window.FLUID || { routes: {}, strings: {}, motion: true };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, o);
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || F.moneyFormat || '{{amount}}';
    const value = (Number(cents) || 0) / 100;
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const type = m ? m[1] : 'amount';
    let out;
    const fixed = (n, d, ts, ds) => { const p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p.join(ds); };
    switch (type) {
      case 'amount_no_decimals': out = fixed(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fixed(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fixed(value, 0, '.', ','); break;
      case 'amount_with_space_separator': out = fixed(value, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = fixed(value, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': out = fixed(value, 2, "'", '.'); break;
      default: out = fixed(value, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  F.formatMoney = formatMoney;

  /* ---------- Sparkle burst ---------- */
  const layer = () => $('.sparkle-layer');
  function sparkleBurst(x, y, n) {
    if (!F.motion || reduceMotion) return;
    const L = layer(); if (!L) return;
    const colors = ['', 'sparkle-bit--mint', 'sparkle-bit--sky', 'sparkle-bit--lemon', 'sparkle-bit--lavender', 'sparkle-bit--peach', 'sparkle-bit--drop'];
    n = n || 12;
    for (let i = 0; i < n; i++) {
      const s = document.createElement('span');
      s.className = 'sparkle-bit ' + colors[i % colors.length];
      const a = (Math.PI * 2 * i) / n + Math.random() * 0.6;
      const d = 40 + Math.random() * 70;
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--dx', Math.cos(a) * d + 'px');
      s.style.setProperty('--dy', Math.sin(a) * d - 30 + 'px');
      s.style.animationDelay = Math.random() * 80 + 'ms';
      L.appendChild(s);
      setTimeout(() => s.remove(), 1200);
    }
  }
  F.sparkleBurst = sparkleBurst;
  function burstFrom(el) { const r = el.getBoundingClientRect(); sparkleBurst(r.left + r.width / 2, r.top + r.height / 2); }

  /* ---------- Focus trap & dialogs ---------- */
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function trapFocus(container) {
    const els = $$(FOCUSABLE, container).filter(e => e.offsetParent !== null || e === document.activeElement);
    if (!els.length) return () => {};
    const first = els[0], last = els[els.length - 1];
    const handler = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', handler);
    return () => container.removeEventListener('keydown', handler);
  }

  class Drawer {
    constructor(el) {
      this.el = el; this.opener = null; this.untrap = null;
      $$('[data-drawer-close]', el).forEach(b => on(b, 'click', () => this.close()));
      on(el.querySelector('.drawer__overlay'), 'click', () => this.close());
      on(document, 'keydown', e => { if (e.key === 'Escape' && this.isOpen) this.close(); });
    }
    get isOpen() { return this.el.classList.contains('is-open'); }
    open(opener) {
      this.opener = opener || document.activeElement;
      this.el.classList.add('is-open'); this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      const focusTarget = this.el.querySelector('[data-autofocus]') || this.el.querySelector(FOCUSABLE);
      setTimeout(() => { focusTarget && focusTarget.focus({ preventScroll: true }); this.untrap = trapFocus(this.el); }, 60);
      this.el.dispatchEvent(new CustomEvent('drawer:open'));
    }
    close() {
      if (!this.isOpen) return;
      this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      this.untrap && this.untrap();
      this.opener && this.opener.focus && this.opener.focus({ preventScroll: true });
    }
  }
  const drawers = {};
  $$('.drawer[data-drawer]').forEach(el => { drawers[el.dataset.drawer] = new Drawer(el); });
  F.drawers = drawers;
  $$('[data-drawer-open]').forEach(btn => on(btn, 'click', e => {
    const d = drawers[btn.dataset.drawerOpen]; if (d) { e.preventDefault(); d.open(btn); }
  }));

  /* ---------- Header ---------- */
  const header = $('.site-header');
  function setHeaderH() { if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); }
  setHeaderH(); on(window, 'resize', debounce(setHeaderH, 150));
  if (header && !header.classList.contains('site-header--static')) {
    const sentinel = document.createElement('div'); sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px';
    header.parentNode.insertBefore(sentinel, header);
    new IntersectionObserver(([e]) => header.classList.toggle('is-stuck', !e.isIntersecting), { rootMargin: '-2px 0px 0px 0px' }).observe(sentinel);
  }
  $$('.site-nav__link[aria-expanded]').forEach(link => {
    on(link, 'click', e => {
      if (link.getAttribute('href') && link.getAttribute('href') !== '#' && window.matchMedia('(hover:hover)').matches) return;
      e.preventDefault();
      const open = link.getAttribute('aria-expanded') === 'true';
      $$('.site-nav__link[aria-expanded="true"]').forEach(l => { l.setAttribute('aria-expanded', 'false'); l.nextElementSibling && l.nextElementSibling.classList.remove('is-open'); });
      link.setAttribute('aria-expanded', String(!open));
      link.nextElementSibling && link.nextElementSibling.classList.toggle('is-open', !open);
    });
  });
  on(document, 'click', e => { if (!e.target.closest('.site-nav__item')) $$('.site-nav__link[aria-expanded="true"]').forEach(l => { l.setAttribute('aria-expanded', 'false'); l.nextElementSibling && l.nextElementSibling.classList.remove('is-open'); }); });
  $$('.mobile-nav__item > .mobile-nav__link[data-toggle]').forEach(link => on(link, 'click', e => {
    e.preventDefault(); const li = link.parentElement; const open = li.classList.toggle('is-open'); link.setAttribute('aria-expanded', String(open));
  }));

  /* ---------- Cart ---------- */
  const Cart = {
    async request(url, body) {
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await r.json();
      if (!r.ok) throw data;
      return data;
    },
    sectionsToRender() {
      const ids = ['cart-icon-bubble'];
      if ($('#CartDrawer')) ids.push('cart-drawer');
      if ($('#MainCart')) ids.push($('#MainCart').dataset.sectionId);
      return ids;
    },
    async add(items, opener) {
      const body = { items: Array.isArray(items) ? items : [items], sections: this.sectionsToRender().join(','), sections_url: window.location.pathname };
      const data = await this.request(F.routes.cart_add || '/cart/add', body);
      this.renderSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      if (F.cartType === 'drawer' && drawers.cart) drawers.cart.open(opener); else this.toast(F.strings.addedToCart);
      return data;
    },
    async change(line, quantity) {
      const data = await this.request(F.routes.cart_change || '/cart/change', { line, quantity, sections: this.sectionsToRender().join(','), sections_url: window.location.pathname });
      this.renderSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      return data;
    },
    async update(fields) {
      const data = await this.request(F.routes.cart_update || '/cart/update', Object.assign({ sections: this.sectionsToRender().join(','), sections_url: window.location.pathname }, fields));
      this.renderSections(data.sections);
      return data;
    },
    renderSections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(id => {
        const html = sections[id]; if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-icon-bubble') {
          const fresh = doc.querySelector('[data-cart-count]');
          $$('[data-cart-count]').forEach(c => { if (fresh) { c.textContent = fresh.textContent; c.dataset.count = fresh.dataset.count; c.classList.remove('is-bumping'); void c.offsetWidth; c.classList.add('is-bumping'); } });
          return;
        }
        if (id === 'cart-drawer') {
          const target = $('#CartDrawer [data-cart-drawer-content]'); const fresh = doc.querySelector('[data-cart-drawer-content]');
          if (target && fresh) target.innerHTML = fresh.innerHTML;
          return;
        }
        const target = document.getElementById('shopify-section-' + id) || $(`[data-section-id="${id}"]`);
        const fresh = doc.getElementById('shopify-section-' + id) || doc.querySelector(`[data-section-id="${id}"]`);
        if (target && fresh) target.innerHTML = fresh.innerHTML;
      });
      bindCartUI();
    },
    toast(msg) {
      let t = $('.cart-toast');
      if (!t) { t = document.createElement('div'); t.className = 'cart-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
      t.innerHTML = '<svg class="icon" viewBox="0 0 24 24"><path d="M5 12l5 5L20 7"/></svg>' + msg;
      t.classList.add('is-visible'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-visible'), 2600);
    }
  };
  F.Cart = Cart;

  function bindCartUI() {
    $$('[data-cart-item]').forEach(item => {
      if (item.dataset.bound) return; item.dataset.bound = '1';
      const line = Number(item.dataset.line);
      const input = $('[data-qty-input]', item);
      const setQty = async (q) => {
        item.classList.add('is-loading');
        try { await Cart.change(line, q); } catch (err) { item.classList.remove('is-loading'); Cart.toast((err && err.message) || F.strings.cartError); }
      };
      $$('[data-qty-minus]', item).forEach(b => on(b, 'click', () => setQty(Math.max(0, Number(input.value) - 1))));
      $$('[data-qty-plus]', item).forEach(b => on(b, 'click', () => setQty(Number(input.value) + 1)));
      on(input, 'change', () => setQty(Math.max(0, Number(input.value) || 0)));
      $$('[data-remove]', item).forEach(b => on(b, 'click', e => { e.preventDefault(); setQty(0); }));
    });
    $$('[data-cart-note]').forEach(t => { if (t.dataset.bound) return; t.dataset.bound = '1'; on(t, 'change', () => Cart.update({ note: t.value })); });
  }
  bindCartUI();

  /* ---------- Quantity input (generic) ---------- */
  $$('.qty:not([data-cart-item] .qty)').forEach(q => {
    const input = $('input', q); if (!input || q.closest('[data-cart-item]')) return;
    on($('[data-qty-minus]', q), 'click', () => { input.value = Math.max(Number(input.min) || 1, Number(input.value) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
    on($('[data-qty-plus]', q), 'click', () => { const max = Number(input.max) || 9999; input.value = Math.min(max, Number(input.value) + 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  /* ---------- Quick add ---------- */
  on(document, 'click', async e => {
    const btn = e.target.closest('[data-quick-add]'); if (!btn) return;
    e.preventDefault();
    const id = Number(btn.dataset.quickAdd); if (!id) return;
    btn.classList.add('is-loading'); btn.disabled = true;
    try {
      await Cart.add({ id, quantity: 1 }, btn);
      btn.classList.remove('is-loading'); btn.classList.add('is-success'); burstFrom(btn);
      setTimeout(() => { btn.classList.remove('is-success'); btn.disabled = false; }, 1600);
    } catch (err) {
      btn.classList.remove('is-loading'); btn.disabled = false;
      Cart.toast((err && (err.description || err.message)) || F.strings.cartError);
    }
  });

  /* ---------- Product form + variant picker ---------- */
  class ProductForm {
    constructor(root) {
      this.root = root;
      this.form = $('form[data-product-form]', root);
      this.data = JSON.parse($('[data-product-json]', root).textContent);
      this.idInput = $('input[name="id"]', this.form);
      this.priceEl = $('[data-price]', root);
      this.button = $('[data-add-button]', this.form);
      this.buttonText = $('[data-add-text]', this.button);
      this.error = $('[data-form-error]', this.form);
      this.inventory = $('[data-inventory]', root);
      this.stickyPrice = $('[data-sticky-price]');
      this.stickyBtn = $('[data-sticky-add]');
      this.sku = $('[data-sku]', root);
      this.optionInputs = $$('[data-option-input]', root);
      this.gallery = root.querySelector('fluid-gallery');
      this.selectedVariant = this.data.variants.find(v => v.id === Number(this.idInput.value)) || this.data.variants[0];
      this.optionInputs.forEach(i => on(i, 'change', () => this.onOptionChange()));
      on(this.form, 'submit', e => this.onSubmit(e));
      if (this.stickyBtn) on(this.stickyBtn, 'click', () => { this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit(); });
      this.updateAvailabilityMarks();
    }
    currentOptions() {
      const groups = {};
      this.optionInputs.forEach(i => {
        if (i.tagName === 'SELECT') groups[i.dataset.optionIndex] = i.value;
        else if (i.checked) groups[i.dataset.optionIndex] = i.value;
      });
      return Object.keys(groups).sort().map(k => groups[k]);
    }
    onOptionChange() {
      const opts = this.currentOptions();
      const v = this.data.variants.find(v => v.options.every((o, i) => o === opts[i]));
      this.selectedVariant = v || null;
      this.updateAvailabilityMarks();
      this.render();
    }
    updateAvailabilityMarks() {
      const opts = this.currentOptions();
      this.optionInputs.forEach(i => {
        if (i.tagName === 'SELECT') {
          $$('option', i).forEach(o => {
            const idx = Number(i.dataset.optionIndex);
            const test = opts.slice(); test[idx] = o.value;
            const match = this.data.variants.find(v => v.options.every((x, j) => j === idx ? x === o.value : (j < idx ? x === test[j] : true)));
            const anyAvail = this.data.variants.some(v => v.available && v.options[idx] === o.value && v.options.every((x, j) => j >= idx || x === test[j]));
            o.textContent = o.dataset.label + (match && !anyAvail ? ' — ' + F.strings.soldOut : '');
          });
        } else {
          const idx = Number(i.dataset.optionIndex);
          const test = opts.slice(); test[idx] = i.value;
          const anyAvail = this.data.variants.some(v => v.available && v.options[idx] === i.value && v.options.every((x, j) => j >= idx || x === test[j]));
          const chip = i.nextElementSibling; if (chip) chip.classList.toggle('is-unavailable', !anyAvail);
        }
      });
      $$('[data-option-value]', this.root).forEach(el => { const idx = Number(el.dataset.optionValue); el.textContent = opts[idx] || ''; });
    }
    render() {
      const v = this.selectedVariant;
      if (!v) {
        this.setButton(false, F.strings.unavailable); return;
      }
      this.idInput.value = v.id;
      if (this.priceEl) this.priceEl.innerHTML = this.priceHTML(v);
      if (this.stickyPrice) this.stickyPrice.innerHTML = this.priceHTML(v);
      if (this.sku) this.sku.textContent = v.sku || '';
      if (this.inventory) {
        const info = (this.data.inventory || {})[v.id];
        this.inventory.hidden = !info || !info.text; if (info) { this.inventory.textContent = info.text; this.inventory.className = 'product__inventory ' + (info.cls || ''); }
      }
      this.setButton(v.available, v.available ? (v.inventory_policy === 'continue' && v.inventory_quantity <= 0 && v.inventory_management ? F.strings.addToCart : F.strings.addToCart) : F.strings.soldOut);
      if (v.featured_media && this.gallery) this.gallery.goToMedia(v.featured_media.id);
      const url = new URL(window.location); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
    }
    priceHTML(v) {
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      let h = `<div class="price price--large${onSale ? ' price--on-sale' : ''}${v.available ? '' : ' price--sold-out'}">`;
      if (onSale) h += `<span class="price__sale"><span class="price-item price-item--regular">${formatMoney(v.compare_at_price)}</span><span class="price-item price-item--sale">${formatMoney(v.price)}</span></span>`;
      h += `<span class="price__regular"><span class="price-item price-item--regular">${formatMoney(v.price)}</span></span>`;
      if (v.unit_price_measurement && v.unit_price) h += `<span class="price__unit">${formatMoney(v.unit_price)} / ${v.unit_price_measurement.reference_value !== 1 ? v.unit_price_measurement.reference_value : ''}${v.unit_price_measurement.reference_unit}</span>`;
      return h + '</div>';
    }
    setButton(enabled, text) {
      this.button.disabled = !enabled; this.button.setAttribute('aria-disabled', String(!enabled));
      if (this.buttonText) this.buttonText.textContent = text;
      if (this.stickyBtn) { this.stickyBtn.disabled = !enabled; const t = $('[data-add-text]', this.stickyBtn); if (t) t.textContent = text; }
    }
    async onSubmit(e) {
      e.preventDefault();
      if (this.button.disabled) return;
      const fd = new FormData(this.form);
      const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
      const props = {}; fd.forEach((val, key) => { const m = key.match(/^properties\[(.+)\]$/); if (m && val) props[m[1]] = val; });
      if (Object.keys(props).length) item.properties = props;
      const sp = fd.get('selling_plan'); if (sp) item.selling_plan = Number(sp);
      this.button.classList.add('is-loading'); this.error && (this.error.hidden = true);
      try {
        await Cart.add(item, this.button);
        this.button.classList.remove('is-loading'); this.button.classList.add('is-success');
        const t = this.buttonText && this.buttonText.textContent; if (this.buttonText) this.buttonText.textContent = F.strings.addedToCart;
        burstFrom(this.button);
        setTimeout(() => { this.button.classList.remove('is-success'); if (this.buttonText) this.buttonText.textContent = t; }, 1800);
      } catch (err) {
        this.button.classList.remove('is-loading');
        if (this.error) { this.error.textContent = (err && (err.description || err.message)) || F.strings.cartError; this.error.hidden = false; }
      }
    }
  }
  $$('[data-product-root]').forEach(r => { try { new ProductForm(r); } catch (e) { console.warn('FLUID product form', e); } });

  /* ---------- Gallery ---------- */
  class FluidGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('.gallery__track', this); this.slides = $$('.gallery__slide', this);
      this.thumbs = $$('.gallery__thumb', this); this.dots = $$('.gallery__dot', this);
      this.index = 0;
      on($('.gallery__nav--prev', this), 'click', () => this.go(this.index - 1));
      on($('.gallery__nav--next', this), 'click', () => this.go(this.index + 1));
      this.thumbs.forEach((t, i) => on(t, 'click', () => this.go(i)));
      this.dots.forEach((d, i) => on(d, 'click', () => this.go(i)));
      on(this.track, 'scroll', debounce(() => { const i = Math.round(this.track.scrollLeft / this.track.clientWidth); if (i !== this.index) { this.index = i; this.mark(); } }, 60));
      on(this, 'keydown', e => { if (e.key === 'ArrowRight') this.go(this.index + 1); if (e.key === 'ArrowLeft') this.go(this.index - 1); });
    }
    go(i) { if (!this.slides.length) return; i = (i + this.slides.length) % this.slides.length; this.index = i; this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); this.mark(); }
    goToMedia(id) { const i = this.slides.findIndex(s => Number(s.dataset.mediaId) === Number(id)); if (i > -1) this.go(i); }
    mark() {
      this.thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === this.index); t.setAttribute('aria-current', i === this.index ? 'true' : 'false'); if (i === this.index) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); });
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.index));
      this.slides.forEach((s, i) => { const v = s.querySelector('video'); if (v && i !== this.index) v.pause(); });
    }
  }
  if (!customElements.get('fluid-gallery')) customElements.define('fluid-gallery', FluidGallery);

  /* ---------- Sticky ATC ---------- */
  const sticky = $('.sticky-atc'), mainBtn = $('[data-add-button]');
  if (sticky && mainBtn) {
    let btnVisible = true;
    const updateSticky = () => sticky.classList.toggle('is-visible', !btnVisible && window.scrollY > 240);
    new IntersectionObserver(([e]) => { btnVisible = e.isIntersecting; updateSticky(); }, { threshold: 0 }).observe(mainBtn);
    on(window, 'scroll', debounce(updateSticky, 80), { passive: true });
  }

  /* ---------- Share ---------- */
  $$('[data-share]').forEach(b => on(b, 'click', async () => {
    const url = b.dataset.share || location.href; const title = document.title;
    if (navigator.share) { try { await navigator.share({ title, url }); return; } catch (e) { /* cancelled */ } }
    try { await navigator.clipboard.writeText(url); Cart.toast(b.dataset.shareSuccess || 'Link copied'); } catch (e) { /* noop */ }
  }));

  /* ---------- Predictive search ---------- */
  const searchModal = $('#SearchModal');
  if (searchModal) {
    const input = $('input[type="search"]', searchModal), results = $('[data-search-results]', searchModal);
    let lastOpener = null, untrap = null;
    const openSearch = (opener) => { lastOpener = opener; searchModal.classList.add('is-open'); searchModal.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open'); setTimeout(() => { input.focus(); untrap = trapFocus(searchModal); }, 40); };
    const closeSearch = () => { searchModal.classList.remove('is-open'); searchModal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open'); untrap && untrap(); lastOpener && lastOpener.focus(); };
    $$('[data-search-open]').forEach(b => on(b, 'click', e => { e.preventDefault(); openSearch(b); }));
    $$('[data-search-close]', searchModal).forEach(b => on(b, 'click', closeSearch));
    on(searchModal, 'click', e => { if (e.target === searchModal) closeSearch(); });
    on(document, 'keydown', e => { if (e.key === 'Escape' && searchModal.classList.contains('is-open')) closeSearch(); if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); openSearch(document.activeElement); } });
    const fetchResults = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      results.setAttribute('aria-busy', 'true');
      try {
        const url = `${F.routes.predictive || '/search/suggest'}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const r = await fetch(url); const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('#shopify-section-predictive-search');
        results.innerHTML = inner ? inner.innerHTML : '';
      } catch (e) { results.innerHTML = ''; }
      results.setAttribute('aria-busy', 'false');
    }, 220);
    on(input, 'input', fetchResults);
  }

  /* ---------- Collection filtering & sorting ---------- */
  const facetsForm = $('#FacetsForm');
  const grid = $('#CollectionGrid');
  if (facetsForm && grid) {
    const sectionId = grid.dataset.sectionId;
    const applyUrl = async (searchParams, push) => {
      grid.classList.add('is-loading');
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      try {
        const r = await fetch(url); const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['#CollectionGrid', '#CollectionCount', '#ActiveFacets', '#FacetsForm .facets', '#CollectionPagination', '#FacetsCount'].forEach(sel => {
          const t = $(sel), s = doc.querySelector(sel); if (t && s) t.innerHTML = s.innerHTML;
        });
        if (push !== false) history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`);
        const top = $('#CollectionTop'); if (top && push !== false) { const y = top.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0) - 12; if (window.scrollY > y) window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' }); }
        bindFacetInputs(); initReveal();
      } catch (e) { window.location.search = searchParams; }
      grid.classList.remove('is-loading');
    };
    const serialize = () => {
      const fd = new FormData(facetsForm); const p = new URLSearchParams();
      fd.forEach((v, k) => { if (v !== '' && v !== null) p.append(k, v); });
      const sort = $('#SortBy'); if (sort && sort.value) p.set('sort_by', sort.value);
      return p.toString();
    };
    const onChange = debounce(() => applyUrl(serialize()), 150);
    function bindFacetInputs() {
      $$('input,select', facetsForm).forEach(i => { if (i.dataset.bound) return; i.dataset.bound = '1'; on(i, 'change', onChange); });
    }
    bindFacetInputs();
    on(facetsForm, 'submit', e => { e.preventDefault(); applyUrl(serialize()); drawers.filters && drawers.filters.close(); });
    on($('#SortBy'), 'change', onChange);
    on(document, 'click', e => {
      const a = e.target.closest('[data-facet-remove], #CollectionPagination a'); if (!a) return;
      e.preventDefault(); const u = new URL(a.href); applyUrl(u.searchParams.toString());
    });
    on(window, 'popstate', e => applyUrl((e.state && e.state.searchParams) || window.location.search.replace(/^\?/, ''), false));
  }

  /* ---------- Recently viewed ---------- */
  const RV_KEY = 'fluid:recent';
  const rv = (() => { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; } })();
  const rvRoot = $('[data-product-root]');
  if (rvRoot && rvRoot.dataset.handle) {
    const list = [rvRoot.dataset.handle].concat(rv.filter(h => h !== rvRoot.dataset.handle)).slice(0, 12);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) { /* noop */ }
  }
  $$('[data-recently-viewed]').forEach(async sec => {
    const exclude = sec.dataset.exclude; const limit = Number(sec.dataset.limit) || 4;
    const handles = rv.filter(h => h !== exclude).slice(0, limit);
    if (!handles.length) { sec.closest('.shopify-section') && (sec.closest('.shopify-section').hidden = true); return; }
    const container = $('[data-rv-grid]', sec);
    const cards = await Promise.all(handles.map(async h => {
      try { const r = await fetch(`${F.routes.root === '/' ? '' : F.routes.root}/products/${h}?section_id=product-card-standalone`); if (!r.ok) return ''; const html = await r.text(); const d = new DOMParser().parseFromString(html, 'text/html'); const c = d.querySelector('.product-card'); return c ? c.outerHTML : ''; } catch (e) { return ''; }
    }));
    const html = cards.filter(Boolean).join('');
    if (!html) { sec.closest('.shopify-section') && (sec.closest('.shopify-section').hidden = true); return; }
    container.innerHTML = html; sec.hidden = false; initReveal();
  });

  /* ---------- Reveal on scroll ---------- */
  let revealIO;
  function initReveal() {
    if (!F.motion || reduceMotion || !('IntersectionObserver' in window)) { $$('.reveal').forEach(e => e.classList.add('is-in')); return; }
    revealIO = revealIO || new IntersectionObserver(entries => entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal:not(.is-in)').forEach(e => revealIO.observe(e));
  }
  initReveal();

  /* ---------- Announcement ticker ---------- */
  $$('.announcement-bar--ticker .announcement-bar__track').forEach(t => { t.innerHTML += t.innerHTML; });

  /* ---------- Newsletter feedback ---------- */
  $$('form[data-newsletter]').forEach(f => on(f, 'submit', () => { const b = $('button[type="submit"]', f); b && burstFrom(b); }));
  if (location.hash && /newsletter|footer|contact/.test(location.hash)) { const el = $(location.hash); el && el.scrollIntoView({ block: 'center' }); }

  /* ---------- Theme editor hooks ---------- */
  on(document, 'shopify:section:load', () => { initReveal(); bindCartUI(); $$('[data-product-root]').forEach(r => { if (!r.dataset.init) { r.dataset.init = '1'; try { new ProductForm(r); } catch (e) {} } }); });
  on(document, 'shopify:section:select', e => { const d = e.target.querySelector('.drawer[data-drawer]'); if (d && drawers[d.dataset.drawer]) drawers[d.dataset.drawer].open(); });
  on(document, 'shopify:section:deselect', e => { const d = e.target.querySelector('.drawer[data-drawer]'); if (d && drawers[d.dataset.drawer]) drawers[d.dataset.drawer].close(); });

  /* ---------- Hover sparkle on display headings ---------- */
  if (F.motion && !reduceMotion && window.matchMedia('(hover:hover)').matches) {
    $$('[data-sparkle-hover]').forEach(el => on(el, 'mouseenter', e => sparkleBurst(e.clientX, e.clientY, 7)));
  }
})();
